import { render, staticRenderFns } from "./DraggableDiv.vue?vue&type=template&id=0de9126e&"
import script from "./DraggableDiv.vue?vue&type=script&lang=js&"
export * from "./DraggableDiv.vue?vue&type=script&lang=js&"
import style0 from "./DraggableDiv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports